<template>
    <div class="flex flex-col h-full overflow-hidden">
        <navigation-bars/>
        <div class="flex flex-grow w-full overflow-hidden">
            <side-bar v-if="showSideBar" :isRolled="isRolled" @roll-side-bar="rollSidebar"/>
            <div class="flex flex-col h-full overflow-x-hidden shrink w-full">
                <routes-access
                    :popupVisible="popupVisible"
                    :items="validationRoutes"
                    :message="validationRoutesMessage"
                />
                <slot/>
                <save-userdata-popup v-if="mainState.isSavePopupVisible"/>
                <div class="h-[20px] w-[300px] flex items-center justify-center border fixed bottom-0 right-0">
                    {{ dbVersion?.host }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'main-layout',
};
</script>

<script setup>
import NavigationBars from '@/layouts/main-layout/components/navigation-bars.vue';
import SaveUserdataPopup from './components/save-userdata-popup/save-userdata-popup.vue';
import {onBeforeMount, ref} from 'vue';
import enviromentStore from '@/store/enviroment-data';
import {routes} from '@/router';
import {routesProcessing} from '@/main';
import {getCookie} from '@/utils/cookies';
import {auth} from '@/service/http';
import {openTabListGet} from '@/service/userdata-service';
import {initContextGroups, mainState} from './main-layout-data';
import {getDataBaseVersion} from '@/service/meta-service';
import SideBar from "@/layouts/main-layout/components/side-bar/side-bar.vue";

const {getRoutePermission, getUserData, getOfficialUserData} = enviromentStore;

const validationRoutesMessage = ref('');
const validationRoutes = ref([]);
const popupVisible = ref(false);
const isRolled = ref(true);
const dbVersion = ref();
const showSideBar = ref(false);

const rollSidebar = () => {
    isRolled.value = !isRolled.value;
};

onBeforeMount(async () => {
    const data = await openTabListGet();

    const args = {
        appId: +getCookie('app'),
        depId: +getCookie('dep'),
    };
    const resp = await auth('userdata./userdata/user-data/get', args);

    await getUserData();
    await getOfficialUserData();

    dbVersion.value = await getDataBaseVersion();

    if (routes.length === 9) {
        await routesProcessing();
    }
    const res = await getRoutePermission();
    if (res && res.items) {
        validationRoutesMessage.value = res.message;
        validationRoutes.value = res.items;
        if (res.items.length !== 1 || res.items.findIndex(item => item === '/infoenergo/setpassword/&/:uuid') === -1) {
            popupVisible.value = true;
        } else {
            validationRoutesMessage.value = '';
            validationRoutes.value = [];
        }
    }
    showSideBar.value = args.appId === 10;
    if (showSideBar.value) {
        await initContextGroups();
    }
});
</script>
